export default (editor, config = {}) => {
  const deviceManager = editor.DeviceManager
  // deviceManager.add('Extra Small', '575px')
  // deviceManager.add('Small', '767px')
  // deviceManager.add('Medium', '991px')
  // deviceManager.add('Large', '1199px')
  // deviceManager.add('Extra Large', '100%')
  //
  window.testDM = deviceManager.getAll()
  const panels = editor.Panels
  panels.removePanel({ id: 'devices-c' })

  const panelEditor = panels.addPanel({ id: 'preview' })
  panelEditor.get('buttons').add([{
    id: 'preview-desktop',
    command: 'preview-desktop',
    // label: ' 代码模式',
    active: false,
    className: 'fa fa-desktop',
    attributes: { 'title': wwjs.i18n('以桌面方式预览') }
  },
  {
    'id': 'wwsave',
    'command': 'wwsave',
    'className': 'fa fa-save',
    'title': '保存',
    'data-tooltip-pos': 'bottom'
  }])

  // const panelEditor = panels.addPanel({ id: 'editor' })
  // panelEditor.get('buttons').add([{
  //   id: 'code-editor',
  //   command: 'code-editor',
  //   label: ' 代码模式',
  //   active: false,
  //   className: 'fa fa-code'
  // }])

  // let deviceBtns = [['set-device-desktop', '桌面'], ['set-device-tablet', '平板'], ['set-device-mobile', '手机']]
  // deviceBtns.forEach((item) => {
  //   let btn = panels.getButton('devices-c', item[0])
  //   btn.set('attributes', { title: item[1], 'data-tooltip-pos': 'bottom' })
  //   // console.log(btn)
  //   btn.set('active', 1)
  // })

  // let btn = panels.getButton('editor', 'code-editor')
  // btn.set('attributes', { title: '切换到代码模式', 'data-tooltip-pos': 'bottom' })
  // btn.set('active', 1)

  // deviceBtns.forEach((item) => {
  //   let btn = panels.getButton('devices-c', item[0])
  //   btn.set('attributes', { title: item[1], 'data-tooltip-pos': 'bottom' })
  //   // console.log(btn)
  //   btn.set('active', 1)
  // })
  // deviceBtns.add([{
  //   id: 'deviceXl',
  //   command: 'set-device-xl',
  //   className: 'fa fa-television ',
  //   text: 'XL',
  //   attributes: { 'title': wwjs.i18n('宽屏(大于1199px)') },
  //   active: 1
  // }, {
  //   id: 'deviceLg',
  //   command: 'set-device-lg',
  //   className: 'fa fa-desktop',
  //   attributes: { 'title': wwjs.i18n('桌面(991～1199px)') }
  // }, {
  //   id: 'deviceMd',
  //   command: 'set-device-md',
  //   className: 'fa fa-tablet',
  //   attributes: { 'title': wwjs.i18n('平板(767～991px)') }
  // }, {
  //   id: 'deviceSm',
  //   command: 'set-device-sm',
  //   className: 'fa fa-mobile',
  //   attributes: { 'title': wwjs.i18n('手机(575～767px)') }
  // }, {
  //   id: 'deviceXs',
  //   command: 'set-device-xs',
  //   className: 'fa fa-clock-o',
  //   attributes: { 'title': wwjs.i18n('腕表(小于575px)') }
  // }])
  //
  // commands.add('set-device-xs', {
  //   run: function (editor) {
  //     editor.setDevice('Extra Small')
  //   }
  // })
  // commands.add('set-device-sm', {
  //   run: function (editor) {
  //     editor.setDevice('Small')
  //   }
  // })
  // commands.add('set-device-md', {
  //   run: function (editor) {
  //     editor.setDevice('Medium')
  //   }
  // })
  // commands.add('set-device-lg', {
  //   run: function (editor) {
  //     editor.setDevice('Large')
  //   }
  // })
  // commands.add('set-device-xl', {
  //   run: function (editor) {
  //     editor.setDevice('Extra Large')
  //   }
  // })
}
